import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed713d42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cargo Por Manejo")
], -1))
const _hoisted_8 = { class: "card overflow-scroll" }
const _hoisted_9 = { class: "table table-hover table-sm" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Cargo"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Naturaleza"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre Naturaleza"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1))

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { UrlGlobal } from '@/store/dominioGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'CargCaMan',
  setup(__props) {

const dUrl = UrlGlobal()

const cargos = ref<Array>([]);
const naturalezas: Record<string, string> = {};

const getCargos = () => {
axios.get( dUrl.urlGlobal +'/api2/cargcaman/')
  .then(response => {
    cargos.value = response.data;
  })
  .catch(error => {
    console.error('Error fetching cargos:', error);
  });
};

const getNaturalezas = () => {
axios.get( dUrl.urlGlobal + '/api2/carnatur/')
  .then(response => {
    response.data.forEach((naturaleza: { naturaleza: string, nombre: string }) => {
      naturalezas[naturaleza.naturaleza] = naturaleza.nombre;
    });
  })
  .catch(error => {
    console.error('Error fetching naturalezas:', error);
  });
};

const getNombreNaturaleza = (naturalezaId: string) => {
return naturalezas[naturalezaId] || 'N/A';
};

onMounted(() => {
getCargos();
getNaturalezas();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cargos.value, (cargo) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: cargo.cargo
                      }, [
                        _createElementVNode("td", null, _toDisplayString(cargo.cargo), 1),
                        _createElementVNode("td", null, _toDisplayString(cargo.nombre), 1),
                        _createElementVNode("td", null, _toDisplayString(cargo.naturaleza), 1),
                        _createElementVNode("td", null, _toDisplayString(getNombreNaturaleza(cargo.naturaleza)), 1),
                        _createElementVNode("td", null, _toDisplayString(cargo.status), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})